import { createZodDto } from 'nestjs-zod/dto';
import { SsoUserCreateSchema } from './sso-user-create.dto';
export const SsoUserMergeSchema = SsoUserCreateSchema;
export class SsoUserMergeDto extends createZodDto(SsoUserMergeSchema) {
}
